import React from 'react';
import { Spinner, Title1 } from "@fluentui/react-components";

interface DashboardLoaderProps {
    isLoading: boolean;
    loadingText?: string;
}

const DashboardLoader: React.FC<DashboardLoaderProps> = ({ 
    isLoading, 
    loadingText = "Loading dashboard data ..."
}) => {
    return (
        <>
            {/* Dashboard loading indicator */}
            {isLoading && (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '200px',
                    flexDirection: 'column',
                    gap: '16px'
                }}>
                    <Spinner size="large" />
                    <Title1>{loadingText}</Title1>
                </div>
            )}
        </>
    );
};

export default DashboardLoader;
